'use strict';

const _=require('pulsar-utils/dist-es6/_');
const GenerateEnum=require('pulsar-utils/dist-es6/domain/generateEnum');


const EmiratesSearchType=GenerateEnum(['PairingOrFlight','DateAndTime','StaffId'],'EmiratesSearchType');

EmiratesSearchType.addGetter('label',function(val){return _.startCase(val).
replace(/\bAnd\b/g,'and').
replace(/\Or\b/g,'or').
replace(/\Id\b/g,'ID')});

Object.freeze(EmiratesSearchType);

module.exports=EmiratesSearchType;
//# sourceMappingURL=emiratesSearchType.js.map
